import ThemeLetter from './ThemeLetter'

import { LETTER_BUTTON_CLASS } from '../../constants/topic-list'

class ThemeLetters {
  constructor(el) {
    if (!el) return

    this.themeLettersEl = el
    this.themeLetters = this.initThemeLetters()
  }

  initThemeLetters() {
    return Array.from(this.themeLettersEl.querySelectorAll(`.${LETTER_BUTTON_CLASS}`)).map(
      letterEl => new ThemeLetter(letterEl)
    )
  }

  findLetterElByLetter(searchableLetter) {
    return this.themeLetters.find(({ letter }) => letter === searchableLetter)
  }

  deactivateLetterButtons() {
    this.themeLetters.map(themeLetter => themeLetter.deactivate())
  }
}

export default ThemeLetters
